module.exports = __webpack_public_path__ + "static/media/View_Icon.b9c4afb6.svg";